import React from 'react';
import type { ChangeEvent } from 'react';
import type { TravelerFormValues } from '../../../../api/reservationInfo';
import type { TravelerFieldRules } from '../utils';

type Props = {
  travelerFieldRules: TravelerFieldRules;
  traveler: TravelerFormValues;
  travelerErrors: Partial<Record<keyof TravelerFormValues, string>>;
  onSelectChange: (field: keyof TravelerFormValues) => (e: ChangeEvent<HTMLSelectElement>) => void;
  disabled: boolean;
};

const ReservationInfoAirGenderField = ({
  travelerFieldRules,
  traveler,
  travelerErrors,
  onSelectChange,
  disabled
}: Props) => {
  const { isRequired, isVisible } = travelerFieldRules;
  if (!isVisible('flight_gender')) return null;
  const styles = getStyles();

  return (
    <div style={styles.formGroup}>
      <label htmlFor="traveler-flightGender" style={styles.label}>
        性別
        {isRequired('flight_gender') && <span style={styles.required}>*</span>}
      </label>
      <select
        id="traveler-flightGender"
        style={{
          ...styles.select,
          ...(travelerErrors.flightGender ? styles.inputError : {})
        }}
        value={traveler.flightGender}
        onChange={onSelectChange('flightGender')}
        disabled={disabled}
      >
        <option value="">選択してください</option>
        <option value="male">男性</option>
        <option value="female">女性</option>
      </select>
      {travelerErrors.flightGender && <span style={styles.errorText}>{travelerErrors.flightGender}</span>}
    </div>
  );
};

const getStyles = (): Record<string, React.CSSProperties> => ({
  formGroup: {
    marginBottom: '16px'
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '6px',
    color: '#333'
  },
  required: {
    color: '#e74c3c',
    marginLeft: '4px'
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxSizing: 'border-box' as const,
    outline: 'none'
  },
  select: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxSizing: 'border-box' as const,
    outline: 'none',
    backgroundColor: '#fff',
    cursor: 'pointer'
  },
  inputError: {
    borderColor: '#e74c3c'
  },
  errorText: {
    color: '#e74c3c',
    fontSize: '12px',
    marginTop: '4px',
    display: 'block'
  }
});

export default ReservationInfoAirGenderField;
